import React from "react";
import Grid from "@material-ui/core/Grid";
import Title from "./Title";

const Trivia = ({
  accion: {
    _id,
    tipo,
    tieneRanking,
    trivia: { urlReporte, urlEdicion }
  }
}) => {
  const onEdit = () => window.open(urlEdicion);
  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <Title
          tipo={tipo}
          onClick={onEdit}
          clipboard={`/trivia/${_id}`}
          tieneRanking={tieneRanking}
          rankingUrl={`/ranking/${_id}`}
        />
      </Grid>
      {urlReporte && (
        <Grid item xs={12}>
          <iframe src={urlReporte} height="800" width="100%" title={_id} />;
        </Grid>
      )}
    </Grid>
  );
};
Trivia.defaultProps = { accion: { trivia: {} } };
Trivia.displayName = "TRIVIA";

export default Trivia;
